import { Dialog, DialogContent, Divider, DialogActions, Button, Typography, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import ConfigurationOptionsService from "../../services/ConfigurationOptionsService";
import theme from "../../styles/main-theme";
import { makeStyles } from "@mui/styles";
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';

interface AboutDialogProps {
    open: boolean;
    onClose: () => void
}

const AboutDialog = (props: AboutDialogProps) => {
    const { t } = useTranslation();
    const [buildNumber, setBuildNumber] = useState<string>("");
    const nowYear = new Date().getFullYear();
    const getBuildNumber = async () => {
        const buildNumber = await ConfigurationOptionsService.GetBuildNumber();
        if (buildNumber)
            setBuildNumber(buildNumber)
    };

    useEffect(() => {
        getBuildNumber();
    }, []);

    const classes = makeStyles({
        btn: {
            color: theme.palette.primary.dark,
            backgroundColor: theme.palette.secondary.dark,
            textTransform: 'none',
            fontSize: '1.1em',
            cursor: 'pointer',
            borderRadius: "20px",
            margin: "5px",
            "&:hover": {
                backgroundColor: theme.palette.info.dark
            }
        },
        hdr1: {
            fontWeight: 'bold',
            color: theme.palette.primary.main
        }
    })();

    return (
        <Dialog open={props.open} onClose={() => props.onClose()} aria-label="error dialog">
            <DialogContent sx={{ marginTop: "15px", color: theme.palette.grey[700] }}>
                <Typography className={classes.hdr1} sx={{ fontSize: '1.2em' }}>SimForm™ Build {buildNumber}</Typography>
                <br />
                <Typography className={classes.hdr1} sx={{ fontSize: '0.9em' }}>© Copyright {nowYear} {t("Maya HTT, Ltd. All rights reserved")}.</Typography>
                <Divider />
                <br />
                <br />
                <Typography>SimForm™ {t("contains the following libraries covered by the MIT License")}:</Typography>
                <br />
                <Typography sx={{ fontWeight: 'bold' }}>
                    <Tooltip
                        title={"https://github.com/idealab-isu/GPView/blob/master/LICENSE"}><Link href="https://github.com/idealab-isu/GPView/blob/master/LICENSE">GPView</Link>
                    </Tooltip>
                </Typography>
                <Typography sx={{ color: theme.palette.info.light }}>© {t("Copyright 2018 Iowa State University (ISU) & ISU IDEALab")}</Typography>
            </DialogContent>
            <DialogActions>
                <Button className={classes.btn} onClick={(e) => { props.onClose(); }}>{t("Ok")}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default AboutDialog;